import axios from 'axios';
import config from '../config/config';

// Create base axios instance
const api = axios.create({
  baseURL: config.api.baseUrl,
  headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
  },
  withCredentials: true, // Enable sending cookies with requests
  xsrfCookieName: 'XSRF-TOKEN', // Spring's default CSRF cookie name
  xsrfHeaderName: 'X-XSRF-TOKEN' // Spring's default CSRF header name
});

api.interceptors.request.use(
  (config) => {
    // You can add auth tokens here if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common error cases
api.interceptors.response.use(
  (response) => {
    // Check if this is a binary response
    if (response.config.responseType === 'arraybuffer') {
      return response;  // Return full response for binary data
    }
    return response.data;  // Otherwise, return just the data
  },
  (error) => {
    console.error(`API Error [${error.config?.url}]:`, error.response?.data || error.message);
    if (error.response?.status === 401) {
      // Handle unauthorized access
    }
    return Promise.reject(error);
  }
);

export default api;
